import { render, staticRenderFns } from "./form.vue?vue&type=template&id=e31ce71c&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=e31ce71c&prod&lang=css"
import style1 from "./form.vue?vue&type=style&index=1&id=e31ce71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31ce71c",
  null
  
)

export default component.exports